import { forwardRef } from 'react';
import { NavLink, type NavLinkProps } from 'react-router-dom';

import { localizedPath, useCurrentLocale } from '../../lib/locale';

type LocaleLinkProps = Omit<NavLinkProps, 'to'> & { to: string };

/**
 * Internal link that automatically carries the active locale prefix.
 * Use this instead of NavLink/Link anywhere in the public site.
 *
 * Forwards its ref so a caller can move focus to it: NavDropdown returns focus to the trigger
 * when Esc closes the panel, and focus that goes nowhere is a dead end for keyboard users (§17).
 */
export const LocaleLink = forwardRef<HTMLAnchorElement, LocaleLinkProps>(function LocaleLink(
  { to, ...props },
  ref,
) {
  const locale = useCurrentLocale();
  return <NavLink ref={ref} to={localizedPath(to, locale)} {...props} />;
});
